module.exports = __webpack_public_path__ + "img/9791195014668.93c03453.jpg";